export class ZeitauswahlChange {
    von: Date;
    bis: Date;
    aggregieren: string;
    aktuellerZeitinterval: string;
}
